import React, { useEffect, useRef, useState } from "react";
import AddUnits from "./add_units/add_units_flow_page.js";
import UpdateInventory from "./update_inventory/UpdateInventory";
import "./manage_inventory.css";
import {
  Free,
  Inuse,
  NextIcon,
  PlanEditIcon,
  PrevIcon,
  SearchIco,
  Status,
  TotalStock,
} from "../../../../../utility/index.js";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { api } from "../../../../../utility/AxiosInceptor.js";
import CommonLoaderBlue from "../../billingModel/billingmodel_configurations/Loaders/components/Loader/LoaderBlue.js";
import { Checkbox } from "primereact/checkbox";
import { OverlayPanel } from "primereact/overlaypanel";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import BulkUpdate from "./add_units/add_units_components/bulkupdate/BulkUpdate.js";
const Manage_inventory = ({ isPermitted }) => {
  const listLimit = 18;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagination, setCurrentPagination] = useState({});
  const [floatPagesLeft, setFloatPagesLeft] = useState([]);
  const [floatPagesRight, setFloatPagesRight] = useState([]);
  const [overlayContent, setOverlayContent] = useState("");
  const OverlayRef = useRef(null);
  const [addUnits, setAddUnits] = useState(false);
  const [updateInventory, setUpdateInventory] = useState(false);
  const [updateInventoryType, setUpdateInventoryType] = useState("");
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const inventoryFiltersRef = useRef(null);
  const [statusFiltersSelected, setStatusFiltersSelected] = useState({
    billingModel: "",
    status: "",
    carrier: "",
  });
  const [dataTableVal, setDataTableVal] = useState([]);
  const loginData = JSON.parse(localStorage.getItem("userData"));
  const [refreshInventoryData, setRefreshInventoryData] = useState(false);
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  let model = JSON.parse(localStorage.getItem("permissions"));

  useEffect(() => {
    const fetchData = () => {
      setIsLoading(true);

      api
        .get(`/api/web/simInventory/inventoryDashboard`, {
          params: {
            serviceProvider: loginData?.company,
            billingModel: statusFiltersSelected.billingModel,
            status: statusFiltersSelected.status,
            carrier:
              statusFiltersSelected?.carrier &&
              statusFiltersSelected?.carrier?.join(","),
            inventoryType: statusFiltersSelected.inventoryType,
            make: statusFiltersSelected.make,
            page: currentPage,
            filter: statusFiltersSelected.filter,
            model: statusFiltersSelected.model,
            limit: listLimit,
          },
        })
        .then((res) => {
          setCurrentPagination({
            total: res?.data?.meta.totalRecords,
            limit: listLimit,
            page: res?.data?.meta?.page,
            totalPages: res?.data?.meta?.totalPages,
          });
          setData(res?.data);
          setDataTableVal(res?.data?.data);
          if (res?.data?.meta?.totalPages > 6) {
            if (
              floatPagesLeft.length === 0 ||
              res?.data?.meta?.totalPages !== currentPagination.totalPages
            ) {
              setFloatPagesLeft([1, 2, 3]);

              setFloatPagesRight([
                res?.data?.meta?.totalPages - 1,
                res?.data?.meta?.totalPages,
              ]);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    const debouncedFetch = debounce(fetchData, 500); // adjust delay as needed

    debouncedFetch();

    return () => {
      debouncedFetch.cancel(); // cleanup on unmount or before next debounce call
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshInventoryData, currentPage]);
  useEffect(() => {
    setCurrentPage(1);
    setRefreshInventoryData((prev) => prev + 1);
  }, [statusFiltersSelected]);
  const [billingModelList, setBillingModelList] = useState([]);
  useEffect(() => {
    api
      .get(`/api/billingModel/all?serviceProvider=${parseLoginRes?.company}`)
      .then((res) => {
        let permittedroutes = [];
        if (
          model.some(
            (element) =>
              element.moduleName === "Prepaid SIMs" &&
              element.subModules.some(
                (subModule) => subModule.subModuleName === "New Enrollments",
              ),
          )
        ) {
          permittedroutes.push("Prepaid SIMs");
        }
        if (
          model.some(
            (element) =>
              element.moduleName === "Postpaid Connections" &&
              element.subModules.some(
                (subModule) => subModule.subModuleName === "New Enrollments",
              ),
          )
        ) {
          permittedroutes.push("Postpaid Connections");
        }
        let billingmodels = res?.data?.data;
        let permittedbillingmodel = [];
        for (let i = 0; i < billingmodels?.length; i++) {
          if (
            billingmodels[i].billingModel === "PREPAID" &&
            permittedroutes.includes("Prepaid SIMs")
          ) {
            permittedbillingmodel.push(billingmodels[i]);
          } else if (
            billingmodels[i].billingModel === "POSTPAID" &&
            permittedroutes.includes("Postpaid Connections")
          ) {
            permittedbillingmodel.push(billingmodels[i]);
          }
        }
        setBillingModelList(permittedbillingmodel);
      })
      .catch((err) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const actionref = useRef(null);
  const [rowData, setRowData] = useState(null);
  const actionsrole = (rowData) => {
    return (
      <>
        <div className="flex align-items-center justify-content-end">
          <div
            onClick={(e) => {
              actionref.current.toggle(e);
              setRowData(rowData);
            }}
          >
            <span className="actionbtnmain">
              <PlanEditIcon />
            </span>
          </div>
          <div className="roleoverlay">
            <OverlayPanel
              ref={actionref}
              style={{ width: "11rem", height: "5.5rem" }}
            >
              <div className="flex flex-column w-full overlay">
                <div
                  className="flex  justify-content-start align-items-center overlaycontent"
                  style={{
                    height: "3.6rem",
                    paddingLeft: "1.45rem",
                    width: "10.8rem",
                    marginTop: ".8rem",
                  }}
                  onClick={() => {
                    setUpdateInventoryType("single");
                    setUpdateInventory(true);
                    actionref.current.hide();
                  }}
                >
                  <div className="inner">
                    <label>Update</label>
                  </div>
                </div>
              </div>
            </OverlayPanel>
          </div>
          {/* <Button icon="pi pi-trash" rounded outlined severity="danger" onClick={() => handleRoleDelete(rowData)} /> */}
        </div>
      </>
    );
  };
  const [carrier, setCarrier] = useState(null);
  //Make Options
  useEffect(() => {
    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        let carrierholder = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].name;
          obj.value = res.data.data[i]._id;
          carrierholder.push(obj);
        }

        setCarrier(carrierholder);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [inventoryList, setinventoryList] = useState([]);
  useEffect(() => {
    api
      .get(`/api/inventoryType/all`, {
        params: {
          serviceProvider: parseLoginRes?.company,
        },
      })
      .then((res) => {
        setinventoryList(res?.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="manage-inventory-main-main">
      {addUnits || (updateInventory && updateInventoryType === "single") ? (
        <AddUnits
          rowData={rowData}
          setRefreshInventoryData={setRefreshInventoryData}
          setAddUnits={setAddUnits}
          isUpload={addUnits}
          updateType={updateInventoryType}
          setUpdateInventory={setUpdateInventory}
        />
      ) : updateInventory && updateInventoryType === "bulk" ? (
        <BulkUpdate
          setRefreshInventoryData={setRefreshInventoryData}
          setUpdateInventory={setUpdateInventory}
        />
      ) : updateInventory ? (
        <UpdateInventory
          setRefreshInventoryData={setRefreshInventoryData}
          setUpdateInventory={setUpdateInventory}
        />
      ) : (
        <div className="manageinventorymain">
          <div className="manageinventoryheader">
            <h1>Manage Inventory</h1>
            <p>
              View and manage your inventory, including available stock and
              items in use, along with their details.
            </p>
          </div>
          <div className="stock">
            <div className="stockinner">
              <div className="head">
                <span>
                  <TotalStock /> <p>TOTAL STOCK</p>
                </span>
              </div>
              <div className="count">
                <h1>{data?.total}</h1>
                <div className="innerinfo">
                  <span>{data?.yesterdayTotal}</span>

                  <p>since yesterday</p>
                </div>
              </div>
            </div>
            <div className="stockinner">
              <div className="head">
                <span>
                  <Free /> <p>FREE</p>
                </span>
              </div>
              <div className="count">
                <h1>{data?.free}</h1>
                <div className="innerinfo">
                  <span>{data?.yesterdayFree}</span>
                  <p>since yesterday</p>
                </div>
              </div>
            </div>
            <div className="stockinner">
              <div className="head">
                <span>
                  <Inuse /> <p>IN USE</p>
                </span>
              </div>
              <div className="count">
                <h1>{data?.inUse}</h1>
                <div className="innerinfo">
                  <span>{data?.yesterdayInUse}</span>
                  <p>since yesterday</p>
                </div>
              </div>
            </div>
          </div>
          <div className="filtersdiv">
            <div
              className="flex align-items-center"
              style={{ height: "4.2rem" }}
            >
              <h1>Stock</h1>
            </div>
            <div className="filters">
              <Dropdown
                placeholder="Select Make"
                optionLabel="make"
                options={inventoryList}
                showClear
                value={statusFiltersSelected.make}
                onChange={(e) => {
                  setStatusFiltersSelected((prev) => ({
                    ...prev,
                    make: e.value,
                  }));
                }}
                optionValue="make"
                className="manageinventory-select"
              />
              <Dropdown
                showClear
                placeholder="Select Model"
                optionLabel="model"
                options={inventoryList}
                value={statusFiltersSelected.model}
                onChange={(e) => {
                  setStatusFiltersSelected((prev) => ({
                    ...prev,
                    model: e.value,
                  }));
                }}
                optionValue="model"
                className="manageinventory-select"
              />
              <Dropdown
                showClear
                placeholder="Inventory Type"
                optionLabel="inventoryType"
                options={inventoryList}
                value={statusFiltersSelected.inventoryType}
                onChange={(e) => {
                  setStatusFiltersSelected((prev) => ({
                    ...prev,
                    inventoryType: e.value,
                  }));
                }}
                optionValue="inventoryType"
                className="manageinventory-select"
              />
              <div className="flex flex-wrap flex-row justify-content-center align-items-center topbarsearchmain">
                <div style={{ position: "relative", width: "100%" }}>
                  <span
                    style={{
                      position: "absolute",
                      left: "1rem",
                      top: "55%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                  >
                    <SearchIco />
                  </span>
                  <InputText
                    className="topbarsearch"
                    value={statusFiltersSelected.filter}
                    placeholder="Enter Imei,Esn or Box No"
                    onChange={(e) => {
                      setStatusFiltersSelected((prev) => ({
                        ...prev,
                        filter: e.target.value,
                      }));
                    }}
                    style={{
                      backgroundColor: "transparent",
                      paddingLeft: "4rem",
                      width: "21.8rem",
                    }}
                  />
                </div>
              </div>
              <span
                onClick={(e) => inventoryFiltersRef.current.toggle(e)}
                className="svgicon"
              >
                <Status />
              </span>
              <OverlayPanel
                ref={inventoryFiltersRef}
                style={{
                  width: "20rem",
                  marginLeft: "-7rem",
                  marginTop: "1rem",
                }}
              >
                <div
                  style={{
                    paddingTop: "0.8rem",
                    boxShadow: "0 1px 0.3rem rgba(0, 0, 0, 0.3)",
                    paddingBottom: "0.8rem",
                  }}
                  className="flex flex-column w-full overlay"
                >
                  <div
                    className="flex  justify-content-start align-items-center"
                    style={{ height: "1.8rem", width: "100%" }}
                  >
                    <h1
                      style={{
                        padding: "0rem",
                        margin: "0rem",
                        fontSize: "1.2rem",
                        paddingLeft: "1.2rem",
                        borderBottom: "solid #E1E4F3 1px",
                        width: "100%",
                        fontWeight: "400",
                        lineHeight: "1.6rem",
                        color: "#8B8BA7",
                      }}
                      className=""
                    >
                      Status
                    </h1>
                  </div>
                  <div
                    className="flex  justify-content-start align-items-center overlaycontent"
                    style={{
                      height: "3.6rem",
                      marginTop: "0.4rem",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{ gap: "0.8rem" }}
                      className="flex w-full align-items-center overlayinnerdata"
                    >
                      <Checkbox
                        onChange={(e) => {
                          setCurrentPage(1);
                          setStatusFiltersSelected((prev) => ({
                            ...prev,
                            status:
                              prev.status === "available" ? "" : "available",
                          }));
                        }}
                        checked={statusFiltersSelected.status === "available"}
                      ></Checkbox>
                      <label>Free</label>
                    </div>
                  </div>
                  <div
                    className="flex  justify-content-start align-items-center overlaycontent"
                    style={{ height: "3.6rem", width: "100%" }}
                  >
                    <div
                      style={{ gap: "0.8rem" }}
                      className="flex w-full align-items-center overlayinnerdata"
                    >
                      <Checkbox
                        onChange={(e) => {
                          setCurrentPage(1);
                          setStatusFiltersSelected((prev) => ({
                            ...prev,
                            status: prev.status === "inUse" ? "" : "inUse",
                          }));
                        }}
                        checked={statusFiltersSelected.status === "inUse"}
                      ></Checkbox>
                      <label>Use</label>
                    </div>
                  </div>
                  <div
                    className="flex  justify-content-start align-items-center overlaycontent"
                    style={{ height: "3.6rem", width: "100%" }}
                  >
                    <div
                      style={{ gap: "0.8rem" }}
                      className="flex w-full align-items-center overlayinnerdata"
                    >
                      <Checkbox
                        onChange={(e) =>
                          setStatusFiltersSelected((prev) => ({
                            ...prev,
                            status:
                              prev.status === "discarded" ? "" : "discarded",
                          }))
                        }
                        checked={statusFiltersSelected.status === "discarded"}
                      ></Checkbox>
                      <label>Discarded</label>
                    </div>
                  </div>
                  <div
                    className="flex  justify-content-start align-items-center"
                    style={{
                      height: "1.8rem",
                      marginTop: "0.8rem",
                      width: "100%",
                    }}
                  >
                    <h1
                      style={{
                        padding: "0rem",
                        margin: "0rem",
                        fontSize: "1.2rem",
                        paddingLeft: "1.2rem",
                        borderBottom: "solid #E1E4F3 1px",
                        width: "100%",
                        fontWeight: "400",
                        lineHeight: "1.6rem",
                        color: "#8B8BA7",
                      }}
                      className=""
                    >
                      Billing Model
                    </h1>
                  </div>

                  {billingModelList.map((billingModel, index) => (
                    <div
                      className="flex  justify-content-start align-items-center overlaycontent"
                      style={{
                        marginTop: index === 0 ? "0.4rem" : "0rem",
                        height: "3.6rem",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{ gap: "0.8rem" }}
                        className="flex w-full align-items-center overlayinnerdata"
                      >
                        <Checkbox
                          onChange={(e) =>
                            setStatusFiltersSelected((prev) => ({
                              ...prev,
                              billingModel:
                                prev.billingModel === billingModel.billingModel
                                  ? ""
                                  : billingModel.billingModel,
                            }))
                          }
                          checked={
                            statusFiltersSelected.billingModel ===
                            billingModel.billingModel
                          }
                        />
                        <label>{billingModel.billingModel}</label>
                      </div>
                    </div>
                  ))}
                  <div
                    className="flex  justify-content-start align-items-center"
                    style={{
                      height: "1.8rem",
                      marginTop: "0.8rem",
                      width: "100%",
                    }}
                  >
                    <h1
                      style={{
                        padding: "0rem",
                        margin: "0rem",
                        fontSize: "1.2rem",
                        paddingLeft: "1.2rem",
                        borderBottom: "solid #E1E4F3 1px",
                        width: "100%",
                        fontWeight: "400",
                        lineHeight: "1.6rem",
                        color: "#8B8BA7",
                      }}
                      className=""
                    >
                      Carriers
                    </h1>
                  </div>

                  {carrier?.map((carrierhere, index) => (
                    <div
                      className="flex justify-content-start align-items-center overlaycontent"
                      style={{
                        marginTop: index === 0 ? "0.4rem" : "0rem",
                        height: "3.6rem",
                        width: "100%",
                      }}
                      key={carrierhere.value}
                    >
                      <div
                        style={{ gap: "0.8rem" }}
                        className="flex w-full align-items-center overlayinnerdata"
                      >
                        <Checkbox
                          onChange={() =>
                            setStatusFiltersSelected((prev) => {
                              const alreadySelected = prev.carrier.includes(
                                carrierhere.value,
                              );

                              return {
                                ...prev,
                                carrier: alreadySelected
                                  ? prev.carrier.filter(
                                      (c) => c !== carrierhere.value,
                                    )
                                  : [...prev.carrier, carrierhere.value],
                              };
                            })
                          }
                          checked={statusFiltersSelected.carrier.includes(
                            carrierhere.value,
                          )}
                        />
                        <label>{carrierhere.label}</label>
                      </div>
                    </div>
                  ))}
                </div>
              </OverlayPanel>
              {/* <Button
                label="Update Inventory"
                onClick={() => {
                  setUpdateInventory(true);
                }}
                className="backbtn"
                style={{ width: "15rem", height: "4.2rem" }}
              /> */}
              <Button
                label="Bulk Update"
                disabled={!isPermitted("/bulk-update")}
                onClick={() => {
                  setUpdateInventoryType("bulk");
                  setUpdateInventory(true);
                }}
                className="nextbtn"
                style={{ width: "11rem", height: "4.2rem" }}
              />
              <Button
                label="Add Unit"
                disabled={!isPermitted("/add-unit")}
                onClick={() => {
                  setAddUnits(true);
                }}
                className="nextbtn"
                style={{ width: "10rem", height: "4.2rem" }}
              />
            </div>
          </div>
          <div className="datatableinventory">
            <DataTable
              emptyMessage={
                isLoading ? (
                  <div
                    style={{
                      width: "108.4rem",
                      position: "absolute",
                      top: "6rem",
                    }}
                    className="flex p-2 flex-wrap flex-row justify-content-center align-items-center "
                  >
                    <CommonLoaderBlue customSize={14} />
                  </div>
                ) : (
                  ""
                )
              }
              value={dataTableVal}
            >
              <Column field="simNumber" header="SIM Number"></Column>
              <Column
                field="box"
                header="BOX"
                body={(rowData) => (
                  <>
                    <p
                      onMouseEnter={(e) => {
                        if (rowData?.box?.length > 6) {
                          setOverlayContent(rowData?.box);
                          OverlayRef.current.show(e);
                        }
                      }}
                      onMouseLeave={() => OverlayRef?.current?.hide()}
                    >
                      {rowData?.box?.length > 6
                        ? rowData?.box?.substring(0, 6) + "..."
                        : rowData.box}
                    </p>
                    <OverlayPanel ref={OverlayRef}>
                      <div style={{ padding: "0.5rem 1rem" }}>
                        <p
                          style={{
                            fontWeight: 400,
                            fontSize: "1.4rem",
                            overflow: "hidden",
                            border: "none",
                            margin: "0rem",
                            lineHeight: "1.8rem",
                            color: "#72728f",
                          }}
                        >
                          {" "}
                          {overlayContent}
                        </p>
                      </div>
                    </OverlayPanel>
                  </>
                )}
              />
              <Column
                body={(rowData) => (
                  <>
                    <p
                      onMouseEnter={(e) => {
                        if (rowData?.IMEI?.length > 11) {
                          setOverlayContent(rowData?.IMEI);
                          OverlayRef.current.show(e);
                        }
                      }}
                      onMouseLeave={() => OverlayRef?.current?.hide()}
                    >
                      {rowData?.IMEI?.length > 11
                        ? rowData?.IMEI?.substring(0, 11) + "..."
                        : rowData.IMEI}
                    </p>
                    <OverlayPanel ref={OverlayRef}>
                      <div style={{ padding: "0.5rem 1rem" }}>
                        <p
                          style={{
                            fontWeight: 400,
                            fontSize: "1.4rem",
                            overflow: "hidden",
                            border: "none",
                            margin: "0rem",
                            lineHeight: "1.8rem",
                            color: "#72728f",
                          }}
                        >
                          {" "}
                          {overlayContent}
                        </p>
                      </div>
                    </OverlayPanel>
                  </>
                )}
                field="IMEI"
                header="IMEI"
              ></Column>
              <Column field="billingModel" header="BillingModel"></Column>
              <Column field="inventoryType" header="Inventory Type"></Column>
              <Column field="makeAndModel" header="Make and Model"></Column>
              <Column
                field="isEsim"
                header="eSIM"
                body={(rowData) => {
                  const isEsim =
                    rowData?.isEsim === true || rowData?.isEsim === "true";
                  return (
                    <span
                      style={{
                        color: isEsim ? "#27AE60" : "#72728f",
                        fontWeight: 500,
                      }}
                    >
                      {isEsim ? "Yes" : "No"}
                    </span>
                  );
                }}
              ></Column>
              <Column
                field="status"
                body={(rowData) => {
                  return (
                    <span
                      style={{
                        color:
                          rowData?.status === "available"
                            ? "#F39C12"
                            : "#27AE60",
                      }}
                    >
                      {rowData?.status === "available" ? "Free" : "in Use"}
                    </span>
                  );
                }}
                header="Status"
              ></Column>
              <Column body={actionsrole} header="Action"></Column>
            </DataTable>
            <div
              style={{ marginTop: "2.4rem" }}
              className="flex flex-wrap w-full  flex-row justify-content-between align-items-center "
            >
              {true && (
                <h1 className="infoenrollmentsall">
                  {currentPagination?.total
                    ? currentPagination?.page * currentPagination.limit >
                      currentPagination.total
                      ? currentPagination.total
                      : currentPagination?.page * currentPagination.limit
                    : "0"}
                  /{currentPagination?.total ? currentPagination?.total : "0"}
                </h1>
              )}
              {currentPagination?.totalPages > 1 && (
                <div
                  style={{}}
                  className="flex flex-wrap flex-row justify-content-between pages"
                >
                  <button
                    disabled={currentPage === 1}
                    onClick={() => {
                      let pagetocheck = currentPage;
                      pagetocheck--;
                      if (
                        currentPagination.totalPages <= 6 &&
                        pagetocheck > 0
                      ) {
                        setCurrentPage(pagetocheck);
                      } else if (
                        floatPagesLeft.includes(pagetocheck) ||
                        floatPagesRight.includes(pagetocheck)
                      ) {
                        setCurrentPage(pagetocheck);
                      } else if (pagetocheck > 0) {
                        if (pagetocheck === floatPagesLeft[0] - 1) {
                          let arr = floatPagesLeft;

                          arr.pop();
                          arr.unshift(floatPagesLeft[0] - 1);
                          setFloatPagesLeft(arr);
                          setCurrentPage(pagetocheck);
                        } else if (pagetocheck === floatPagesRight[0] - 1) {
                          let arr = floatPagesRight;

                          arr.pop();
                          arr.unshift(floatPagesRight[0] - 1);
                          setFloatPagesRight(arr);
                          setCurrentPage(pagetocheck);
                        }
                      }
                    }}
                    className="cursor-pointer backbtn"
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "500",
                      opacity: currentPage === 1 && "0.6",
                      backgroundColor: "#FFFFFF33",
                      width: "10.6rem",
                      height: "3.8rem",
                      margin: "0rem",
                    }}
                  >
                    <span>
                      <PrevIcon /> &nbsp; Previous
                    </span>
                  </button>
                  <div
                    style={{ maxWidth: "38.9rem", gap: "1rem" }}
                    className="flex flex-wrap flex-row justify-content-start align-items-start"
                  >
                    {currentPagination.totalPages <= 6 ? (
                      [...Array(currentPagination.totalPages)].map(
                        (_, index) => (
                          <Button
                            onClick={() => {
                              setCurrentPage(index + 1);
                            }}
                            style={{ width: "3.1rem", height: "3.4rem" }}
                            key={index + 1}
                            className={
                              currentPagination.page === index + 1
                                ? "pagecounteractive"
                                : "pagecounter"
                            }
                            label={index + 1}
                          />
                        ),
                      )
                    ) : (
                      <>
                        {floatPagesLeft.map((page) => (
                          <Button
                            key={page}
                            onClick={() => {
                              setCurrentPage(page);
                            }}
                            style={{ width: "3.1rem", height: "3.4rem" }}
                            className={
                              currentPagination.page === page
                                ? "pagecounteractive"
                                : "pagecounter"
                            }
                            label={page}
                          />
                        ))}
                        {floatPagesLeft[floatPagesLeft.length - 1] + 1 !==
                          floatPagesRight[0] && (
                          <Button className="pagecounter" label={"..."} />
                        )}

                        {floatPagesRight.map((page) => (
                          <Button
                            onClick={() => {
                              setCurrentPage(page);
                            }}
                            key={page}
                            className={
                              currentPagination.page === page
                                ? "pagecounteractive"
                                : "pagecounter"
                            }
                            label={page}
                          />
                        ))}
                      </>
                    )}
                  </div>
                  <button
                    disabled={currentPage === currentPagination.totalPages}
                    onClick={() => {
                      let pagetocheck = currentPage;
                      pagetocheck++;
                      if (
                        currentPagination.totalPages <= 6 &&
                        pagetocheck > 0 &&
                        pagetocheck <= currentPagination.totalPages
                      ) {
                        setCurrentPage(pagetocheck);
                      } else if (
                        floatPagesLeft.includes(pagetocheck) ||
                        floatPagesRight.includes(pagetocheck)
                      ) {
                        setCurrentPage(pagetocheck);
                      } else if (pagetocheck <= currentPagination.totalPages) {
                        if (
                          pagetocheck ===
                          floatPagesLeft[floatPagesLeft.length - 1] + 1
                        ) {
                          let arr = floatPagesLeft;

                          arr.shift();
                          arr.push(pagetocheck);
                          setFloatPagesLeft(arr);
                          setCurrentPage(pagetocheck);
                        } else {
                          if (
                            pagetocheck ===
                              floatPagesRight[floatPagesRight.length - 1] + 1 &&
                            pagetocheck <= currentPagination.totalPages
                          ) {
                            let arr = floatPagesRight;

                            arr.shift();
                            arr.push(pagetocheck);
                            setFloatPagesRight(arr);
                            setCurrentPage(pagetocheck);
                          }
                        }
                      }
                    }}
                    className="cursor-pointer backbtn"
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "500",
                      opacity:
                        currentPage === currentPagination.totalPages && "0.6",
                      backgroundColor: "#FFFFFF33",
                      width: "8rem",
                      height: "3.8rem",
                    }}
                  >
                    <span className="flex align-items-center">
                      Next &nbsp;
                      <NextIcon />
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Manage_inventory;
